export const setClassNamesMiniCard = (isSelected, isInKickOff, componentPrefix) => {
    return `${isSelected ? `rj-ev-list__${componentPrefix}--selected` : ""} ${isInKickOff ? `rj-ev-list__${componentPrefix}--in-kick-off` : ""}`;
};
//# sourceMappingURL=setClassNamesMiniCard.js.map